<template>
  <ul class="steps steps-vertical">
    <li
      v-for="step of steps"
      :key="step.name"
      :data-content="step.completed ? '✓' : ''"
      class="step"
      :class="step.completed ? 'step-primary' : ''"
    >
      <router-link class="link link-hover" v-if="step.link && !step.completed" :to="step.link">
        {{ step.name }}
      </router-link>
      <div v-else>
        {{ step.name }}
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>
